import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_p55ppsxvzv: FaireBrandEntity = {
  token: "b_p55ppsxvzv",
  type: "brand",
  name: "BAGS-2-SLAY",
  avatarUrl:
    "https://cdn.faire.com/fastly/4d9cb51f66fad3ab2a70b00577cb790da930f3e676430c64b881da837c16a023.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6e556ed6125177597a236ca1b5acdd4f975b28bca2d8890f71a3cac328ee4c84.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4d9cb51f66fad3ab2a70b00577cb790da930f3e676430c64b881da837c16a023.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6e556ed6125177597a236ca1b5acdd4f975b28bca2d8890f71a3cac328ee4c84.jpeg",
  location: "PA, USA",
  minimumOrderDollars: 250,
  rating: 4.3,
  reviewCount: 78,
  isInsider: true,
  description:
    "The Bags-2-Slay brand is inspired by many aspects of life. What started as a handbag brand, is slowly expanding into jewelry and accessories. Designed with the contemporary and stylish female in mind, Bags-2-slay will bring out the inner style icon and beauty in a woman.  The brand has an array of high fashion products that will make any woman feel like they are luxurious by having a one-of-a-kind piece of fashion. The Bags-2-Slay brand strives to be successful while pleasing loyal customers.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:18.326Z",
    importedBy: "entity-db-cli",
  },
};
